var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2916.77 2886.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-11,.cls-13,.cls-16,.cls-3,.cls-45,.cls-6,.cls-7{fill:#fff;}.cls-3{opacity:0.5;}.cls-38,.cls-4{fill:#91b3fa;}.cls-5{fill:#2b69b3;}.cls-6{opacity:0.73;}.cls-7{opacity:0.78;}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10,.cls-13{opacity:0.6;}.cls-12{fill:url(#linear-gradient-4);}.cls-14{fill:#18174a;}.cls-15{fill:url(#linear-gradient-5);}.cls-16{opacity:0.47;}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:#ed1c24;}.cls-20{fill:url(#linear-gradient-8);}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#linear-gradient-21);}.cls-34{fill:url(#linear-gradient-22);}.cls-35{fill:url(#linear-gradient-23);}.cls-36{fill:url(#linear-gradient-24);}.cls-37{fill:url(#linear-gradient-25);}.cls-38{opacity:0.42;}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{opacity:0.88;}.cls-46{fill:url(#linear-gradient-32);}.cls-47{fill:url(#linear-gradient-33);}.cls-48{fill:url(#linear-gradient-34);}.cls-49{fill:url(#linear-gradient-35);}.cls-50{fill:url(#linear-gradient-36);}.cls-51{fill:url(#linear-gradient-37);}.cls-52{fill:url(#linear-gradient-38);}.cls-53{fill:url(#linear-gradient-39);}.cls-54{fill:url(#linear-gradient-40);}.cls-55{fill:url(#linear-gradient-41);}.cls-56{fill:url(#linear-gradient-42);}.cls-57{fill:url(#linear-gradient-43);}.cls-58{fill:url(#linear-gradient-44);}.cls-59{fill:url(#linear-gradient-45);}.cls-60{fill:url(#linear-gradient-46);}.cls-61{fill:url(#linear-gradient-47);}.cls-62{fill:url(#linear-gradient-48);}.cls-63{fill:url(#linear-gradient-49);}.cls-64{fill:url(#linear-gradient-50);}.cls-65{fill:url(#linear-gradient-51);}.cls-66{fill:url(#linear-gradient-52);}.cls-67{fill:url(#linear-gradient-53);}.cls-68{fill:url(#linear-gradient-54);}.cls-69{fill:url(#linear-gradient-55);}.cls-70{fill:url(#linear-gradient-56);}.cls-71{fill:url(#linear-gradient-57);}.cls-72{fill:url(#linear-gradient-58);}.cls-73{fill:url(#linear-gradient-59);}.cls-74{fill:url(#linear-gradient-60);}.cls-75{fill:url(#linear-gradient-61);}.cls-76{fill:url(#linear-gradient-62);}.cls-77{fill:url(#linear-gradient-63);}.cls-78{fill:url(#linear-gradient-64);}.cls-79{fill:url(#linear-gradient-65);}.cls-80{fill:url(#linear-gradient-66);}.cls-81{fill:url(#linear-gradient-67);}.cls-82{fill:url(#linear-gradient-68);}.cls-83{fill:url(#linear-gradient-69);}.cls-84{fill:url(#linear-gradient-70);}.cls-85{fill:url(#linear-gradient-71);}.cls-86{fill:url(#linear-gradient-72);}.cls-87{fill:url(#linear-gradient-73);}.cls-88{fill:url(#linear-gradient-74);}.cls-89{fill:url(#linear-gradient-75);}.cls-90{fill:url(#linear-gradient-76);}.cls-91{fill:url(#linear-gradient-77);}.cls-92{fill:url(#linear-gradient-78);}.cls-93{fill:url(#linear-gradient-79);}.cls-94{fill:url(#linear-gradient-80);}.cls-95{fill:url(#linear-gradient-81);}.cls-96{fill:url(#linear-gradient-82);}.cls-97{fill:url(#linear-gradient-83);}.cls-98{fill:url(#linear-gradient-84);}.cls-99{fill:url(#linear-gradient-85);}.cls-100{fill:url(#linear-gradient-86);}.cls-101{fill:url(#linear-gradient-87);}.cls-102{fill:url(#linear-gradient-88);}.cls-103{fill:url(#linear-gradient-89);}.cls-104{fill:url(#linear-gradient-90);}.cls-105{fill:url(#linear-gradient-91);}.cls-106{fill:url(#linear-gradient-92);}.cls-107{fill:url(#linear-gradient-93);}.cls-108{fill:url(#linear-gradient-94);}.cls-109{fill:url(#linear-gradient-95);}.cls-110{fill:url(#linear-gradient-96);}.cls-111{fill:url(#linear-gradient-97);}.cls-112{fill:url(#linear-gradient-98);}.cls-113{fill:url(#linear-gradient-99);}.cls-114{fill:url(#linear-gradient-100);}.cls-115{fill:url(#linear-gradient-101);}.cls-116{fill:url(#linear-gradient-102);}.cls-117{fill:url(#linear-gradient-103);}.cls-118{fill:url(#linear-gradient-104);}.cls-119{fill:url(#linear-gradient-105);}.cls-120{fill:url(#linear-gradient-106);}.cls-121{fill:url(#linear-gradient-107);}.cls-122{fill:url(#linear-gradient-108);}.cls-123{fill:url(#linear-gradient-109);}.cls-124{fill:url(#linear-gradient-110);}.cls-125{fill:url(#linear-gradient-111);}.cls-126{fill:url(#linear-gradient-112);}.cls-127{fill:url(#linear-gradient-113);}.cls-128{fill:url(#linear-gradient-114);}.cls-129{fill:url(#linear-gradient-115);}.cls-130{fill:url(#linear-gradient-116);}.cls-131{fill:url(#linear-gradient-117);}.cls-132{fill:url(#linear-gradient-118);}.cls-133{fill:url(#linear-gradient-119);}.cls-134{fill:url(#linear-gradient-120);}.cls-135{fill:url(#linear-gradient-121);}.cls-136{fill:url(#linear-gradient-122);}.cls-137{fill:url(#linear-gradient-123);}.cls-138{fill:url(#linear-gradient-124);}.cls-139{fill:url(#linear-gradient-125);}.cls-140{fill:url(#linear-gradient-126);}.cls-141{fill:url(#linear-gradient-127);}.cls-142{fill:url(#linear-gradient-128);}.cls-143{fill:url(#linear-gradient-129);}.cls-144{fill:url(#linear-gradient-130);}.cls-145{fill:url(#linear-gradient-131);}.cls-146{fill:url(#linear-gradient-132);}.cls-147{fill:url(#linear-gradient-133);}.cls-148{fill:url(#linear-gradient-134);}.cls-149{fill:url(#linear-gradient-135);}.cls-150{fill:url(#linear-gradient-136);}.cls-151{fill:url(#linear-gradient-137);}.cls-152{fill:url(#linear-gradient-138);}.cls-153{fill:url(#linear-gradient-139);}.cls-154{fill:url(#linear-gradient-140);}.cls-155{fill:url(#linear-gradient-141);}.cls-156{fill:url(#linear-gradient-142);}.cls-157{fill:url(#linear-gradient-143);}.cls-158{fill:url(#linear-gradient-144);}.cls-159{fill:url(#linear-gradient-145);}.cls-160{fill:url(#linear-gradient-146);}.cls-161{fill:url(#linear-gradient-147);}.cls-162{fill:url(#linear-gradient-148);}.cls-163{fill:url(#linear-gradient-149);}.cls-164{fill:url(#linear-gradient-150);}.cls-165{fill:url(#linear-gradient-151);}.cls-166{fill:url(#linear-gradient-152);}.cls-167{fill:url(#linear-gradient-153);}.cls-168{fill:url(#linear-gradient-154);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3074.23,
    y1: 3244.84,
    x2: 1117.99,
    y2: 1162.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1917.02,
    y1: 1342.7,
    x2: 1206.04,
    y2: 2401.19,
    gradientTransform: "translate(-885.5 -735.56) rotate(-0.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2038.43,
    y1: 1424.26,
    x2: 1327.45,
    y2: 2482.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 518.1,
    y1: 1841.62,
    x2: 816.01,
    y2: 1139.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 603,
    y1: 1691.47,
    x2: -317.94,
    y2: 3766.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 304.75,
    y1: 1840.61,
    x2: 306.27,
    y2: 2230.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 618.42,
    y1: 966.71,
    x2: 315.66,
    y2: 1922.08,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 972.76,
    y1: 1682.99,
    x2: 51.83,
    y2: 3758.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 674.51,
    y1: 1832.13,
    x2: 676.04,
    y2: 2221.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 961.33,
    y1: 1042.97,
    x2: 658.57,
    y2: 1998.34,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1336.42,
    y1: 1687.23,
    x2: 415.48,
    y2: 3762.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1038.16,
    y1: 1836.37,
    x2: 1039.69,
    y2: 2226,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1326.94,
    y1: 1041.02,
    x2: 1024.18,
    y2: 1996.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1298.57,
    y1: 2346,
    x2: 1521.65,
    y2: 2346,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1407.93,
    y1: 1827.88,
    x2: 1409.46,
    y2: 2217.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1682.54,
    y1: 1077.24,
    x2: 1379.78,
    y2: 2032.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1246.59,
    y1: 2824.96,
    x2: -997,
    y2: 2824.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1246.6,
    y1: 2776.04,
    x2: -1004.05,
    y2: 2776.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1223.55,
    y1: 2707.75,
    x2: -1153.24,
    y2: 2707.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1744.17,
    y1: 2819.57,
    x2: -1648.52,
    y2: 2819.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1743.48,
    y1: 2745.93,
    x2: -1603.08,
    y2: 2745.93,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1670.5,
    y1: 2649.14,
    x2: -1586.48,
    y2: 2649.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1285.56,
    y1: 1424.41,
    x2: -1584.66,
    y2: 1689.28,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -724.86,
    y1: 1449.47,
    x2: -489.3,
    y2: 1449.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -953.83,
    y1: 819.98,
    x2: -956.4,
    y2: 1259.86,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2097.84,
    y1: 711.67,
    x2: 1828.72,
    y2: 893.32,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2149.23,
    y1: 794.79,
    x2: -1397.97,
    y2: 889.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -40.25, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -1363.41,
    y1: 2391.18,
    x2: -1189.73,
    y2: 2212.99,
    gradientTransform: "matrix(-0.99, -0.14, -0.14, 0.99, 1185.14, -1543.8)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -1167.45,
    y1: 1557.8,
    x2: -1466.55,
    y2: 1822.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -514.33,
    y1: 1421.8,
    x2: -429.98,
    y2: 1421.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 1100.48, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1263.36,
    y1: 467.65,
    x2: -56.76,
    y2: 2636.83,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1517.48,
    y1: 5970.62,
    x2: 1403.25,
    y2: 6264.71,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 2135.43, -5334.48)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1514.78,
    y1: 6060.54,
    x2: 1314.54,
    y2: 6576.06,
    gradientTransform: "matrix(-0.09, 1, 1, 0.09, -5115.23, -1491.33)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -757.49,
    y1: -3055.19,
    x2: -871.72,
    y2: -2761.09,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -606.84, -2000.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -760.18,
    y1: -2965.27,
    x2: -960.43,
    y2: -2449.74,
    gradientTransform: "matrix(-0.38, -0.93, -0.93, 0.38, -2086.19, 1210.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 6560.61,
    y1: 3824.37,
    x2: 6446.37,
    y2: 4118.47,
    gradientTransform: "matrix(-0.45, 0.89, 0.89, 0.45, 235.15, -6709.84)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 6557.91,
    y1: 3914.29,
    x2: 6357.67,
    y2: 4429.81,
    gradientTransform: "matrix(0.78, 0.63, 0.63, -0.78, -6887.35, -329.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 304.38,
    y1: -9129.57,
    x2: 149.63,
    y2: -8762.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -3968.29,
    y1: 790.17,
    x2: -4082.52,
    y2: 1084.26,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -3855.54,
    y1: 816.62,
    x2: -3969.77,
    y2: 1110.71,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -3910.22,
    y1: 674.55,
    x2: -4024.45,
    y2: 968.64,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -3763.35,
    y1: 723.51,
    x2: -3877.58,
    y2: 1017.59,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1468.85, -2450.3)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -3833.4,
    y1: 909.81,
    x2: -3947.63,
    y2: 1203.9,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -3984.96,
    y1: 909.81,
    x2: -4099.19,
    y2: 1203.9,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -3652.74,
    y1: 1912.61,
    x2: -3766.98,
    y2: 2206.71,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -403.96, -3396.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -3655.44,
    y1: 2002.53,
    x2: -3855.68,
    y2: 2518.05,
    gradientTransform: "matrix(-0.96, 0.26, 0.26, 0.96, -3135.08, -352.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2713.69,
    y1: -3154.01,
    x2: -2827.93,
    y2: -2859.92,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2718.66,
    y1: -3064.97,
    x2: -2918.9,
    y2: -2549.46,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -3092.31,
    y1: -3272.52,
    x2: -3206.54,
    y2: -2978.42,
    gradientTransform: "matrix(0, -1, -0.82, 0, -1794.14, -2420.15)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -3097.27,
    y1: -3183.49,
    x2: -3297.51,
    y2: -2667.97,
    gradientTransform: "matrix(-0.78, -0.62, -0.51, 0.64, -3170.01, 857.99)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -8.22,
    y1: -5322.3,
    x2: -122.45,
    y2: -5028.22,
    gradientTransform: "matrix(0, -1, -0.86, 0, -3623.02, 780.08)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -13.23,
    y1: -6631.44,
    x2: -213.46,
    y2: -6115.97,
    gradientTransform: "matrix(-0.15, -0.99, -0.69, 0.1, -3648.3, 1474.88)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1778.04,
    y1: -4453.96,
    x2: 1663.81,
    y2: -4159.88,
    gradientTransform: "matrix(0.96, -0.28, -0.28, -0.96, -1921.74, -2977.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1775.61,
    y1: -4367.03,
    x2: 1579.12,
    y2: -3861.19,
    gradientTransform: "matrix(0.23, -0.97, -0.97, -0.23, -3741.41, 1594.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 5357.77,
    y1: -3179.08,
    x2: 5243.53,
    y2: -2884.98,
    gradientTransform: "matrix(0.87, 0, 0, -0.81, -3789.21, -1759.9)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 5355.43,
    y1: -4291.57,
    x2: 5158.93,
    y2: -3785.69,
    gradientTransform: "matrix(0.69, -0.53, -0.38, -0.49, -4503.67, 1515.8)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 7928.78,
    y1: -694.93,
    x2: 7814.55,
    y2: -400.84,
    gradientTransform: "matrix(0.48, 0.88, 0.88, -0.48, -2310.07, -6334.11)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 7926.16,
    y1: -608.86,
    x2: 7730.62,
    y2: -105.46,
    gradientTransform: "matrix(0.97, -0.25, -0.25, -0.97, -7071.88, 2300.51)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -3634.63,
    y1: 955,
    x2: -3748.87,
    y2: 1249.1,
    gradientTransform: "matrix(-0.26, -0.97, -0.97, 0.26, 891.76, -3192.05)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -3638.81,
    y1: 1042.72,
    x2: -3837.1,
    y2: 1553.2,
    gradientTransform: "matrix(-0.99, -0.11, -0.11, 0.99, -2524.59, -761.07)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 4196.64,
    y1: 5490.15,
    x2: 4082.4,
    y2: 5784.23,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, -285.45, -6101.12)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 4193.22,
    y1: 5577.05,
    x2: 3996.31,
    y2: 6084.01,
    gradientTransform: "matrix(0.37, 0.93, 0.93, -0.37, -6042.55, -1168.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 4266.52,
    y1: 6545.79,
    x2: 4152.29,
    y2: 6839.86,
    gradientTransform: "matrix(0.37, 0.93, 0.77, -0.31, -5947.85, -1206.49)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 4263.11,
    y1: 6632.69,
    x2: 4066.2,
    y2: 7139.62,
    gradientTransform: "matrix(0.37, 0.93, 0.77, -0.31, -5947.85, -1206.49)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1933.6,
    y1: 4874.46,
    x2: -2047.82,
    y2: 5168.53,
    gradientTransform: "matrix(-1, 0, 0, 0.87, -1129.26, -3535.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -1937.19,
    y1: 6602,
    x2: -2134.11,
    y2: 7108.96,
    gradientTransform: "matrix(-0.76, 0.65, 0.4, 0.48, -3275.54, -1196.54)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 7428.14,
    y1: 2597.99,
    x2: 7313.9,
    y2: 2892.09,
    gradientTransform: "matrix(0.87, 0.5, 0.5, -0.87, -7035.29, -575.37)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 7424.2,
    y1: 2689.6,
    x2: 7221.32,
    y2: 3211.92,
    gradientTransform: "matrix(0.91, 0.41, 0.41, -0.91, -7151.7, 219.98)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1624.11,
    y1: 4679.37,
    x2: -1738.34,
    y2: 4973.44,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, -3666.55, -1635.36)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1626.8,
    y1: 4769.28,
    x2: -1827.03,
    y2: 5284.76,
    gradientTransform: "matrix(-0.66, 0.75, 0.75, 0.66, -3791.41, -1356.12)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 6622.75,
    y1: -2690.95,
    x2: 6508.51,
    y2: -2396.86,
    gradientTransform: "matrix(0.7, -0.71, -0.71, -0.7, -5698.59, 3770.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 6620.16,
    y1: -2604.92,
    x2: 6424.71,
    y2: -2101.73,
    gradientTransform: "matrix(0.7, -0.71, -0.71, -0.7, -5698.59, 3770.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1800.91,
    y1: 6432.44,
    x2: 1724.87,
    y2: 6628.22,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, -2151.18, -4902.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1799.12,
    y1: 6492.3,
    x2: 1665.82,
    y2: 6835.48,
    gradientTransform: "matrix(-0.09, 1, 1, 0.09, -5115.23, -1491.33)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -1116.12,
    y1: -3256.22,
    x2: -1192.16,
    y2: -3060.45,
    gradientTransform: "matrix(-0.38, -0.93, -0.93, 0.38, -2086.19, 1210.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -1117.91,
    y1: -3196.37,
    x2: -1251.21,
    y2: -2853.19,
    gradientTransform: "matrix(-0.38, -0.93, -0.93, 0.38, -2086.19, 1210.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 7070.85,
    y1: 3919.9,
    x2: 6994.8,
    y2: 4115.68,
    gradientTransform: "matrix(0.04, 1, 1, -0.04, -3107.32, -5828.09)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 7069.06,
    y1: 3979.75,
    x2: 6935.76,
    y2: 4322.93,
    gradientTransform: "matrix(0.78, 0.63, 0.63, -0.78, -6887.35, -329.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 70.13,
    y1: -9228.42,
    x2: -84.61,
    y2: -8861.74,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1070.5, -2709.87)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -4320.61,
    y1: 1039.51,
    x2: -4396.65,
    y2: 1235.28,
    gradientTransform: "matrix(-0.97, -0.23, -0.23, 0.97, -2687.79, -962.32)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -4245.55,
    y1: 1057.12,
    x2: -4321.59,
    y2: 1252.89,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1074.91, -2693.18)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -4281.95,
    y1: 962.54,
    x2: -4357.99,
    y2: 1158.31,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -4184.18,
    y1: 995.13,
    x2: -4260.22,
    y2: 1190.9,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1136.71, -2667.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -4230.81,
    y1: 1119.15,
    x2: -4306.86,
    y2: 1314.92,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -4331.7,
    y1: 1119.16,
    x2: -4407.74,
    y2: 1314.92,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -3918.36,
    y1: 2333.21,
    x2: -3994.41,
    y2: 2528.99,
    gradientTransform: "matrix(-0.99, -0.12, -0.12, 0.99, -2378.38, -1895.71)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -3920.16,
    y1: 2393.07,
    x2: -4053.46,
    y2: 2736.25,
    gradientTransform: "matrix(-0.96, 0.26, 0.26, 0.96, -3135.08, -352.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -3146.04,
    y1: -3185.41,
    x2: -3222.08,
    y2: -2989.64,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -3149.34,
    y1: -3126.14,
    x2: -3282.64,
    y2: -2782.97,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -3547.93,
    y1: -3281.26,
    x2: -3623.98,
    y2: -3085.48,
    gradientTransform: "matrix(-0.78, -0.62, -0.51, 0.64, -3170.01, 857.99)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -3551.23,
    y1: -3221.99,
    x2: -3684.53,
    y2: -2878.82,
    gradientTransform: "matrix(-0.78, -0.62, -0.51, 0.64, -3170.01, 857.99)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -303.41,
    y1: -5672.31,
    x2: -379.45,
    y2: -5476.55,
    gradientTransform: "matrix(0, -1, -0.86, 0, -3581.45, 734.85)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -306.76,
    y1: -7090.3,
    x2: -440.05,
    y2: -6747.16,
    gradientTransform: "matrix(-0.15, -0.99, -0.69, 0.1, -3648.3, 1474.88)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1635.43,
    y1: -4826.96,
    x2: 1559.39,
    y2: -4631.19,
    gradientTransform: "matrix(0.23, -0.97, -0.97, -0.23, -3741.41, 1594.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1633.81,
    y1: -4769.09,
    x2: 1503.01,
    y2: -4432.36,
    gradientTransform: "matrix(0.23, -0.97, -0.97, -0.23, -3741.41, 1594.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 5548.68,
    y1: -3706.27,
    x2: 5472.63,
    y2: -3510.49,
    gradientTransform: "matrix(0.87, 0, 0, -0.81, -3572.48, -1941.5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 5547.15,
    y1: -5000.66,
    x2: 5416.34,
    y2: -4663.9,
    gradientTransform: "matrix(0.69, -0.53, -0.38, -0.49, -4503.67, 1515.8)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 8273.54,
    y1: -982.41,
    x2: 8197.5,
    y2: -786.64,
    gradientTransform: "matrix(0.78, 0.62, 0.62, -0.78, -4632.74, -4780.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 8271.79,
    y1: -925.12,
    x2: 8141.63,
    y2: -590.01,
    gradientTransform: "matrix(0.97, -0.25, -0.25, -0.97, -7071.88, 2300.51)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -4004.55,
    y1: 1231.91,
    x2: -4080.6,
    y2: 1427.69,
    gradientTransform: "matrix(-0.53, -0.85, -0.85, 0.53, 188.74, -3145.16)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -4007.33,
    y1: 1290.3,
    x2: -4139.33,
    y2: 1630.12,
    gradientTransform: "matrix(-0.99, -0.11, -0.11, 0.99, -2524.59, -761.07)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 4634.27,
    y1: 5808.8,
    x2: 4558.23,
    y2: 6004.57,
    gradientTransform: "matrix(0.37, 0.93, 0.93, -0.37, -6042.55, -1168.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 4632,
    y1: 5866.65,
    x2: 4500.92,
    y2: 6204.13,
    gradientTransform: "matrix(0.37, 0.93, 0.93, -0.37, -6042.55, -1168.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 4680.93,
    y1: 6900.9,
    x2: 4604.89,
    y2: 7096.66,
    gradientTransform: "matrix(0, 1, 0.83, 0, -4608.45, -3678.91)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 4678.66,
    y1: 6958.75,
    x2: 4547.58,
    y2: 7296.2,
    gradientTransform: "matrix(0.37, 0.93, 0.77, -0.31, -5947.85, -1206.49)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -2039.75,
    y1: 5420.05,
    x2: -2115.79,
    y2: 5615.81,
    gradientTransform: "matrix(-1, 0, 0, 0.87, -839.14, -3725.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -2042.21,
    y1: 7339.21,
    x2: -2173.29,
    y2: 7676.69,
    gradientTransform: "matrix(-0.76, 0.65, 0.4, 0.48, -3275.54, -1196.54)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 7912.79,
    y1: 2580.9,
    x2: 7836.74,
    y2: 2776.68,
    gradientTransform: "matrix(-0.35, 0.94, 0.94, 0.35, 1525.15, -7162.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 7910.17,
    y1: 2641.88,
    x2: 7775.11,
    y2: 2989.59,
    gradientTransform: "matrix(0.91, 0.41, 0.41, -0.91, -7151.7, 219.98)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -1634.44,
    y1: 5203.95,
    x2: -1710.48,
    y2: 5399.71,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1077.84, -4085.14)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -1636.23,
    y1: 5263.8,
    x2: -1769.52,
    y2: 5606.95,
    gradientTransform: "matrix(-0.66, 0.75, 0.75, 0.66, -3791.41, -1356.12)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 6747.88,
    y1: -3092.4,
    x2: 6671.84,
    y2: -2896.63,
    gradientTransform: "matrix(0.99, 0.14, 0.14, -0.99, -4978, -2871.87)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 6746.17,
    y1: -3035.14,
    x2: 6616.05,
    y2: -2700.17,
    gradientTransform: "matrix(0.7, -0.71, -0.71, -0.7, -5698.59, 3770.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2062.1,
    y1: 6149.36,
    x2: 2000.16,
    y2: 6308.83,
    gradientTransform: "matrix(-0.09, 1, 1, 0.09, -5115.23, -1491.33)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2060.64,
    y1: 6198.12,
    x2: 1952.06,
    y2: 6477.65,
    gradientTransform: "matrix(-0.09, 1, 1, 0.09, -5115.23, -1491.33)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -1179.84,
    y1: -2855.53,
    x2: -1241.78,
    y2: -2696.07,
    gradientTransform: "matrix(-0.37, -0.93, -0.93, 0.37, -2086.11, 1186.47)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -1181.3,
    y1: -2806.78,
    x2: -1289.88,
    y2: -2527.24,
    gradientTransform: "matrix(-0.38, -0.93, -0.93, 0.38, -2086.19, 1210.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 6967.82,
    y1: 3573.94,
    x2: 6905.87,
    y2: 3733.41,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -6668.48, -1145.71)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 6966.36,
    y1: 3622.69,
    x2: 6857.77,
    y2: 3902.23,
    gradientTransform: "matrix(0.78, 0.63, 0.63, -0.78, -6887.35, -329.44)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 420.19,
    y1: -9080.69,
    x2: 265.44,
    y2: -8714.02,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1015.73, -2419.42)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -3984.69,
    y1: 1245.99,
    x2: -4046.63,
    y2: 1405.45,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1011.55, -2453.26)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -3923.54,
    y1: 1260.33,
    x2: -3985.49,
    y2: 1419.79,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -3953.2,
    y1: 1183.3,
    x2: -4015.14,
    y2: 1342.76,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -1065.1, -2449.36)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -3873.56,
    y1: 1209.84,
    x2: -3935.5,
    y2: 1369.31,
    gradientTransform: "matrix(-1, 0, 0, 1, -3032.4, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -3911.54,
    y1: 1310.86,
    x2: -3973.48,
    y2: 1470.33,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, -987.1, -2382.54)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -3993.72,
    y1: 1310.86,
    x2: -4055.66,
    y2: 1470.33,
    gradientTransform: "matrix(-0.97, -0.23, -0.23, 0.97, -2632.37, -880.43)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -3536.73,
    y1: 2476.24,
    x2: -3598.67,
    y2: 2635.71,
    gradientTransform: "matrix(-0.86, -0.51, -0.51, 0.86, -859.39, -2829.74)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -3538.19,
    y1: 2525,
    x2: -3646.77,
    y2: 2804.53,
    gradientTransform: "matrix(-0.96, 0.26, 0.26, 0.96, -3135.08, -352.28)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -3063.82,
    y1: -2782.55,
    x2: -3125.77,
    y2: -2623.09,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -3066.51,
    y1: -2734.28,
    x2: -3175.09,
    y2: -2454.75,
    gradientTransform: "matrix(-0.7, -0.72, -0.72, 0.7, -3130.65, 915.24)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -3423.39,
    y1: -2818.19,
    x2: -3485.33,
    y2: -2658.72,
    gradientTransform: "matrix(0, -1, -0.82, 0, -1379.05, -2241.38)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -3426.08,
    y1: -2769.91,
    x2: -3534.66,
    y2: -2490.38,
    gradientTransform: "matrix(-0.78, -0.62, -0.51, 0.64, -3170.01, 857.99)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -456.89,
    y1: -5247.09,
    x2: -518.83,
    y2: -5087.64,
    gradientTransform: "matrix(0, -1, -0.86, 0, -3554.32, 788.04)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -459.64,
    y1: -6572.87,
    x2: -568.21,
    y2: -6293.36,
    gradientTransform: "matrix(-0.15, -0.99, -0.69, 0.1, -3648.3, 1474.88)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1366.1,
    y1: -4536.55,
    x2: 1304.16,
    y2: -4377.09,
    gradientTransform: "matrix(0.24, -0.97, -0.97, -0.24, -3745.7, 1520.32)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1364.78,
    y1: -4489.42,
    x2: 1258.24,
    y2: -4215.13,
    gradientTransform: "matrix(0.23, -0.97, -0.97, -0.23, -3741.41, 1594.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 5111.93,
    y1: -3660.77,
    x2: 5049.99,
    y2: -3501.3,
    gradientTransform: "matrix(0.69, -0.53, -0.49, -0.64, -4417.64, 1627.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 5110.71,
    y1: -4950.13,
    x2: 5004.16,
    y2: -4675.82,
    gradientTransform: "matrix(0.69, -0.53, -0.38, -0.49, -4503.67, 1515.8)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 7921.04,
    y1: -1081.25,
    x2: 7859.1,
    y2: -921.78,
    gradientTransform: "matrix(0.41, 0.91, 0.91, -0.41, -1340.1, -6326.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 7919.61,
    y1: -1034.58,
    x2: 7813.59,
    y2: -761.62,
    gradientTransform: "matrix(0.97, -0.25, -0.25, -0.97, -7071.88, 2300.51)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -3690.63,
    y1: 1499.46,
    x2: -3752.58,
    y2: 1658.93,
    gradientTransform: "matrix(-0.02, -1, -1, 0.02, 2362.99, -2601.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -3692.9,
    y1: 1547.03,
    x2: -3800.42,
    y2: 1823.83,
    gradientTransform: "matrix(-0.99, -0.11, -0.11, 0.99, -2524.59, -761.07)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 4728.16,
    y1: 5451.42,
    x2: 4666.22,
    y2: 5610.89,
    gradientTransform: "matrix(0.37, 0.93, 0.93, -0.37, -6042.55, -1168.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 4726.31,
    y1: 5498.55,
    x2: 4619.53,
    y2: 5773.44,
    gradientTransform: "matrix(0.37, 0.93, 0.93, -0.37, -6042.55, -1168.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 4766.22,
    y1: 6462.07,
    x2: 4704.28,
    y2: 6621.53,
    gradientTransform: "matrix(0.37, 0.93, 0.77, -0.31, -5947.85, -1206.49)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 4764.37,
    y1: 6509.19,
    x2: 4657.6,
    y2: 6784.07,
    gradientTransform: "matrix(0.37, 0.93, 0.77, -0.31, -5947.85, -1206.49)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -1649.42,
    y1: 5374.7,
    x2: -1711.35,
    y2: 5534.16,
    gradientTransform: "matrix(-1, 0, 0, 0.87, -768.54, -3467.27)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -1651.45,
    y1: 7268.13,
    x2: -1758.23,
    y2: 7543.02,
    gradientTransform: "matrix(-0.76, 0.65, 0.4, 0.48, -3275.54, -1196.54)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 7713.57,
    y1: 2279.2,
    x2: 7651.63,
    y2: 2438.67,
    gradientTransform: "matrix(0, 1, 1, 0, -1442.82, -6383.92)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 7711.44,
    y1: 2328.88,
    x2: 7601.43,
    y2: 2612.1,
    gradientTransform: "matrix(0.91, 0.41, 0.41, -0.91, -7151.7, 219.98)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -1244.21,
    y1: 5123.84,
    x2: -1306.15,
    y2: 5283.3,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, -3629.47, -1641.09)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -1245.67,
    y1: 5172.59,
    x2: -1354.24,
    y2: 5452.1,
    gradientTransform: "matrix(-0.66, 0.75, 0.75, 0.66, -3791.41, -1356.12)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 6384.94,
    y1: -2989.93,
    x2: 6323,
    y2: -2830.47,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -5710.98, 3736.62)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 6383.54,
    y1: -2943.29,
    x2: 6277.56,
    y2: -2670.44,
    gradientTransform: "matrix(0.7, -0.71, -0.71, -0.7, -5698.59, 3770.94)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2482.75,2414.25c-173.13,170.35-397.49,290.85-631.3,348.95-599.26,148.91-1422.78,3-1706.44-613.75-73.64-160.13-97.86-336.1-100.57-511C34.52,998.19,397.62,335.88,1022.69,119.08,1357.29,3,1737.85,26.24,2055.85,182.13c676.75,331.73,985.28,1261.53,646.54,1933.7C2646.27,2227.2,2571.2,2327.23,2482.75,2414.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2121,1923.12S1919.08,828.81,2186.24,89.6c18-49.69,87.39-59.32,122.35-16.8C2542.35,357.09,3150.11,1257.59,2121,1923.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2196,1819.39c-1.47,3.35,3.59,5.86,5.54,2.74,71.64-114.91,313.3-637.93,133.45-1430.95-.58-2.55-4.61-2.09-4.26.49C2356.09,581.63,2429.27,1289.82,2196,1819.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2566.79,220.47c-.8-9.06,11.83-12.54,16.67-4.56,77.25,127.36,330.82,608.54,167.29,1206.62-149.63,547.22-350.11,905-430.47,1035.11-15.89,25.73-55.71,24.86-72.07-1.59-96.93-156.76-344.53-608.41-217.71-951.67C2182.06,1094.18,2605.12,653.08,2566.79,220.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2620.17,710.69s144.36,486.36-327.18,1718.6C2293,2429.29,2696.76,1165,2620.17,710.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M580.09,369.11,2039,362.84a151.16,151.16,0,0,1,151.56,142.81l116.77,2114.66a111.47,111.47,0,0,1-108.79,117.57L526.58,2775.45a105.81,105.81,0,0,1-108.17-105.32L409.27,541.4A171.55,171.55,0,0,1,580.09,369.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M584.5,351.94c199.34,26.16,884.78,106.78,1451,60.87a46.08,46.08,0,0,1,49.81,43.24l122,2124.06a53,53,0,0,1-49.58,56c-238.16,15.12-1219,73.83-1569.11,38.68a42,42,0,0,1-37.77-41.41L528.2,401.89A49.83,49.83,0,0,1,584.5,351.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.08,407c191.83,25.18,851.46,102.76,1396.37,58.58a44.33,44.33,0,0,1,47.93,41.61l117.44,2044.08a51,51,0,0,1-47.71,53.87c-229.19,14.55-1173.11,71.05-1510,37.23a40.44,40.44,0,0,1-36.35-39.86L551.89,455A48,48,0,0,1,606.08,407Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M648.37,611.9l22.25,438.24a27.86,27.86,0,0,0,27.15,26.46c81.19,1.94,334.18,7,477-1a31.12,31.12,0,0,0,29.35-30.21c2.37-82.21,7.3-321.5-11.86-421.44a35.11,35.11,0,0,0-33.46-28.42l-479.9-14.72A29.63,29.63,0,0,0,648.37,611.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1019.37,767a94.23,94.23,0,1,1-94.63-93.83A94.22,94.22,0,0,1,1019.37,767Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M783.21,1044.69l300.19-1.29c18.41-.08,29.35-20.45,19.37-35.92-25.67-39.79-79.27-98.17-171.65-95.13-89,2.93-141.59,56.1-168,94.19A24.29,24.29,0,0,0,783.21,1044.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1934.3,644.88a13,13,0,0,0,13-13.51l-.09-2.5a14.28,14.28,0,0,0-13.9-13.63L1399.84,608c-7.4-.1-11.42,5.52-8.93,12.49l5,14c2.49,7,10.58,12.65,18,12.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1400.19,689.74c-7.4-.11-11.42,5.52-8.93,12.49l5,14c2.49,7,10.58,12.64,18,12.61l520.42-2.23a13,13,0,0,0,13-13.51l-.09-2.51a14.29,14.29,0,0,0-13.9-13.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1400.54,772.64c-7.4-.1-11.42,5.52-8.93,12.49l5,14c2.49,7,10.58,12.64,18,12.61L1935,809.5A13,13,0,0,0,1948,796l-.08-2.51A14.3,14.3,0,0,0,1934,779.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M837,1325h-.15l-104-.55c-14.55-.08-26.59-10-28-23.1l-9.52-87.25a18.35,18.35,0,0,1,4.27-13.82,22.18,22.18,0,0,1,15.45-7.69h0c8.77-.64,21.11-1.75,34.18-2.92,27.49-2.46,61.71-5.52,80.95-5.84,13.56-.28,25.34,7.91,28.6,19.79,5.49,19.93,5.17,57.81,4.32,98.17C862.78,1314.6,851.12,1325,837,1325ZM715.5,1199.28a15.43,15.43,0,0,0-10.77,5.29,11.67,11.67,0,0,0-2.76,8.78l9.53,87.25c1.06,9.69,10.24,17,21.36,17.1l104,.55H837c10.46,0,19.12-7.43,19.31-16.62.85-39.84,1.17-77.19-4.07-96.25-2.41-8.77-11.61-15.05-22-14.84-19,.31-53.09,3.37-80.48,5.82-13.09,1.17-25.46,2.28-34.28,2.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M933,1234.7c-7.4,0-11.89,5.87-10,13l7,25.94c1.92,7.15,9.54,12.91,16.94,12.8l950.76-14a13.3,13.3,0,0,0,13.1-13.65l-.31-11.9a13.91,13.91,0,0,0-13.81-13.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M731.26,1222.54h0a16,16,0,0,1,22,5.89l20.68,36.7a5.13,5.13,0,0,0,9.16-.44l50.4-113.52a5.68,5.68,0,0,1,10.88,2.4c-.37,34.66-9.29,100.59-64.43,156,0,0-30.57-11.73-55.38-65.59A16.75,16.75,0,0,1,731.26,1222.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M838,1548h-.16l-104-.55c-14.54-.08-26.59-10-28-23.1l-9.52-87.25a18.31,18.31,0,0,1,4.27-13.81,22.19,22.19,0,0,1,15.45-7.7h0c8.76-.64,21.1-1.74,34.17-2.91,27.49-2.46,61.72-5.53,81-5.85,13.64-.22,25.33,7.91,28.6,19.79,5.48,19.94,5.17,57.82,4.31,98.18C863.74,1537.57,852.08,1548,838,1548Zm-121.52-125.7a15.43,15.43,0,0,0-10.77,5.29,11.68,11.68,0,0,0-2.76,8.78l9.52,87.25c1.06,9.69,10.25,17,21.37,17.1l104,.55H838c10.46,0,19.11-7.43,19.31-16.62.84-39.84,1.17-77.18-4.07-96.24-2.46-8.92-11.49-15-22-14.85-19,.32-53.08,3.37-80.47,5.82-13.1,1.17-25.46,2.28-34.28,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M727.73,1431.84c21.85-1.59,69.33-6.61,91.86-7,9.54-.16,17.94,5.57,20.22,13.84,4.41,16.06,4,48.1,3.35,77.68-.19,8.86-8.3,16-18.23,15.92l-83.14-.45c-10.23,0-18.74-7-19.73-16.06l-7.61-69.72C713.66,1438.84,719.63,1432.43,727.73,1431.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M934,1457.67c-7.4,0-11.89,5.87-10,13l7,25.94c1.92,7.14,9.54,12.9,16.94,12.79l950.76-14a13.31,13.31,0,0,0,13.1-13.65l-.31-11.9a13.91,13.91,0,0,0-13.81-13.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M838.94,1770.93h-.16l-104-.56c-14.54-.07-26.59-10-28-23.1L697.2,1660a18.33,18.33,0,0,1,4.28-13.81,22.19,22.19,0,0,1,15.45-7.7h0c8.76-.63,21.11-1.74,34.17-2.91,27.5-2.46,61.72-5.52,81-5.84,13.57-.26,25.33,7.91,28.6,19.79,5.48,19.93,5.16,57.81,4.31,98.17C864.7,1760.54,853,1770.93,838.94,1770.93ZM717.41,1645.22a15.46,15.46,0,0,0-10.76,5.3,11.66,11.66,0,0,0-2.76,8.77l9.52,87.25c1.06,9.69,10.24,17,21.37,17.11l104,.55h.13c10.46,0,19.11-7.43,19.3-16.62.85-39.84,1.17-77.19-4.07-96.25-2.41-8.78-11.6-15.11-22-14.85-19,.32-53.08,3.37-80.46,5.82-13.1,1.17-25.47,2.28-34.3,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M728.69,1654.81c21.85-1.58,69.33-6.61,91.86-7,9.54-.16,17.94,5.57,20.21,13.84,4.42,16.06,4,48.11,3.35,77.69-.18,8.86-8.29,16-18.22,15.91l-83.14-.44c-10.23-.06-18.75-7-19.74-16.07L715.4,1669C714.62,1661.82,720.59,1655.4,728.69,1654.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M934.91,1680.65c-7.4,0-11.88,5.86-10,13l7,25.94c1.91,7.15,9.54,12.91,16.94,12.8l950.75-14a13.32,13.32,0,0,0,13.11-13.65l-.31-11.91a13.92,13.92,0,0,0-13.81-13.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M839.9,1993.9h-.16l-104-.55c-14.55-.08-26.59-10-28-23.1L698.16,1883a18.36,18.36,0,0,1,4.28-13.82,22.17,22.17,0,0,1,15.44-7.69c8.76-.64,21.09-1.74,34.14-2.91,27.51-2.46,61.74-5.53,81-5.85h.55c13.34,0,24.82,8.08,28,19.8,5.49,19.94,5.17,57.81,4.32,98.18C865.65,1983.52,854,1993.9,839.9,1993.9Zm-6.35-134.45h-.42c-19,.31-53.11,3.37-80.51,5.82-13.08,1.17-25.44,2.28-34.25,2.92h0a15.41,15.41,0,0,0-10.76,5.29,11.67,11.67,0,0,0-2.76,8.78l9.52,87.25c1.06,9.69,10.24,17,21.36,17.1l104,.55h.13c10.46,0,19.11-7.43,19.3-16.62.85-39.84,1.17-77.18-4.07-96.25C852.75,1865.65,843.71,1859.45,833.55,1859.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M729.65,1877.79c21.85-1.59,69.33-6.62,91.85-7,9.55-.16,18,5.57,20.22,13.84,4.42,16,4,48.1,3.35,77.68-.19,8.86-8.29,16-18.23,15.91l-83.14-.44c-10.22,0-18.74-7-19.73-16.06L716.36,1892C715.57,1884.79,721.55,1878.38,729.65,1877.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M935.87,1903.62c-7.4,0-11.89,5.87-10,13l7,25.93c1.92,7.15,9.55,12.91,16.95,12.8l950.75-14a13.3,13.3,0,0,0,13.1-13.65l-.31-11.9a13.9,13.9,0,0,0-13.8-13.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1398.78,77.2c-52.86-36.43-98.68-35.51-130.89-25.85a64.34,64.34,0,0,0-45.41,67.83L1237.05,271l165.59,14S1502.43,148.65,1398.78,77.2ZM1326.51,200a41.28,41.28,0,1,1,41.1-41.46A41.28,41.28,0,0,1,1326.51,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1253.29,206.38a3.35,3.35,0,0,1-3.34-3l-2.32-24.17a3.36,3.36,0,1,1,6.69-.64l2.32,24.17a3.37,3.37,0,0,1-3,3.67ZM1248.75,159a3.36,3.36,0,0,1-3.35-3l-1.76-18.35a60.77,60.77,0,0,1,42.82-64,123.08,123.08,0,0,1,60.18-2.73,3.36,3.36,0,1,1-1.32,6.59,116.56,116.56,0,0,0-56.93,2.58A54,54,0,0,0,1250.34,137l1.76,18.35a3.38,3.38,0,0,1-3,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1011.55,370.05l-.33-76.34a46.59,46.59,0,0,1,48-46.76l526.38,15.77a45.31,45.31,0,0,1,43.86,42.38l4.71,73.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1184.74,274.55a3.37,3.37,0,0,1,0-6.73l22.63-.1h0a3.37,3.37,0,0,1,0,6.73l-22.64.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1039.92,345.32a3.37,3.37,0,0,1-3.37-3.34l-.13-30.88a42.69,42.69,0,0,1,42.46-42.83l83.21-.35h0a3.36,3.36,0,0,1,0,6.72l-83.21.36a36,36,0,0,0-35.76,36.07l.13,30.88a3.35,3.35,0,0,1-3.35,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M846.52,342.82l920.35-4A68,68,0,0,1,1834.14,395l.8,4.49a58.42,58.42,0,0,1-57.27,68.63l-944.23,4.06a38,38,0,0,1-38.11-39.65l1.85-42.26A49.6,49.6,0,0,1,846.52,342.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 63.98,
    y: 1834,
    width: 1599.04,
    height: 988.17,
    rx: 29.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 119.26,
    y: 1893.59,
    width: 1488.48,
    height: 884.49,
    rx: 100.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 195.39,
    y: 1985.77,
    width: 223.08,
    height: 745.9,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 206.08,
    y: 1985.77,
    width: 201.69,
    height: 739.53,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M404.33,2091c-66.11,18.91-132.68,18.42-199.69-.71a29.62,29.62,0,0,1-21.48-28.46V1952.16H427.63V2060A32.27,32.27,0,0,1,404.33,2091Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 305.4,
    cy: 1954.45,
    rx: 122.24,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M232.62,2202.89a570.36,570.36,0,0,0,142.83-.1A19.33,19.33,0,0,1,397.08,2222v443.61a19.37,19.37,0,0,1-15.23,19c-50.73,10.9-102.47,11.37-155.11,2.46a19.37,19.37,0,0,1-16.08-19.11V2222.08A19.41,19.41,0,0,1,232.62,2202.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 565.15,
    y: 1977.29,
    width: 223.08,
    height: 745.9,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 575.85,
    y: 1977.29,
    width: 201.69,
    height: 739.53,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M774.1,2082.56c-66.11,18.91-132.68,18.41-199.7-.72a29.59,29.59,0,0,1-21.47-28.45V1943.68H797.4v107.8A32.3,32.3,0,0,1,774.1,2082.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 675.16,
    cy: 1945.97,
    rx: 122.24,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M602.39,2194.41a570.75,570.75,0,0,0,142.82-.1,19.33,19.33,0,0,1,21.63,19.24v443.6a19.35,19.35,0,0,1-15.22,18.95c-50.74,10.91-102.48,11.37-155.12,2.47a19.37,19.37,0,0,1-16.07-19.11V2213.6A19.41,19.41,0,0,1,602.39,2194.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 928.8,
    y: 1981.53,
    width: 223.08,
    height: 745.9,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 939.5,
    y: 1981.53,
    width: 201.69,
    height: 739.53,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1137.75,2086.8c-66.11,18.91-132.68,18.42-199.69-.72a29.59,29.59,0,0,1-21.48-28.45V1947.92h244.47v107.81A32.28,32.28,0,0,1,1137.75,2086.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1038.82,
    cy: 1950.21,
    rx: 122.24,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M966,2198.65a570.83,570.83,0,0,0,142.83-.1,19.32,19.32,0,0,1,21.62,19.24V2661.4a19.36,19.36,0,0,1-15.22,18.95c-50.73,10.9-102.47,11.36-155.12,2.46a19.37,19.37,0,0,1-16.07-19.11V2217.84A19.41,19.41,0,0,1,966,2198.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1298.57,
    y: 1973.05,
    width: 223.08,
    height: 745.9,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1309.26,
    y: 1973.05,
    width: 201.69,
    height: 739.53,
    rx: 16.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1507.52,2078.32c-66.11,18.91-132.69,18.41-199.7-.72a29.6,29.6,0,0,1-21.48-28.45V1939.43h244.48v107.81A32.3,32.3,0,0,1,1507.52,2078.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1408.58,
    cy: 1941.73,
    rx: 122.24,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1335.81,2190.17a571.22,571.22,0,0,0,142.82-.1,19.33,19.33,0,0,1,21.63,19.24v443.6a19.36,19.36,0,0,1-15.23,19c-50.73,10.91-102.47,11.37-155.11,2.47a19.37,19.37,0,0,1-16.07-19.11V2209.36A19.41,19.41,0,0,1,1335.81,2190.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2104.53,2812.88c42.75,3.7,117,9.7,175.47,12.28,35.16,1.55,55.41-1.9,67.07-6.57,0,1.32-.06,2.56-.11,3.72a12.09,12.09,0,0,1-11.49,11.42c-110.55,6.17-198.46,2.14-229.76.23a8.61,8.61,0,0,1-7-12.94A70.16,70.16,0,0,1,2104.53,2812.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2280,2825.16c-58.51-2.58-132.72-8.58-175.47-12.28,42-51.57,175.47-86.33,175.47-86.33h37.68c25.92,37.36,29.68,72.93,29.39,92C2335.41,2823.26,2315.16,2826.71,2280,2825.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2324,2665l-3.53,69.79a15.93,15.93,0,0,1-13.61,15,62,62,0,0,1-28.31-2.35,18.85,18.85,0,0,1-12.67-14.49L2253.72,2665Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2813.51,2824.64c18.54-2.59,26.93-12.22,30.45-22.52,0,.09,0,.18.07.28,2.72,10.86-3.6,22.12-16.24,27.47-15.29,6.47-32,7.58-45,7-13.91-.57-26.69-6.33-33.71-15.55l-.1-.14C2763,2828.13,2782.58,2829,2813.51,2824.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2726.08,2664.58h31.08c47.34-1,77.07,98.87,86.8,137.54-3.52,10.3-11.91,19.93-30.45,22.52-30.93,4.31-50.54,3.49-64.5-3.42-25.58-33.65-38.26-82.94-44.35-111.71C2697.72,2676.8,2726.08,2664.58,2726.08,2664.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2753.17,2599.8l17.25,68.64a18.62,18.62,0,0,1-9.69,21.11c-9.65,5-23.25,10.16-35.74,8.66a15.57,15.57,0,0,1-12.69-10.38L2687,2615.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2773.75,2619.64c-21.47,19.05-91.31,21.56-91.31,21.56C2430.88,2037.42,2328,1951.65,2328,1951.65c36.33,227.89,5.86,732.42,5.86,732.42-41.51,18.32-95,0-95,0a3889.13,3889.13,0,0,0-128.46-955c170-3.82,260.44-62,290-85.36C2542,1872.23,2773.75,2619.64,2773.75,2619.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2357.12,949.39c32.19,160.53,20.65,447.84,13.08,578.89-2.13,36.83,98.41,152.86,175,384,2,6,1.25,12.46-4.41,15.37-34.79,17.88-234.32,32.49-370.94,39.38-9.11.46-17.9-5.59-19.61-14.55-74-387.83-258.34-844-268-840.64C2012.15,904.3,2357.12,949.39,2357.12,949.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2559,1410.1c-10.34,74.78-40.88,156.35-102,243l-23.23-18.94s26.82-108.78,11.57-232.23C2483,1394.57,2527.55,1402.15,2559,1410.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2321.18,1147.46l35.94-198.07S2597.29,1133,2559,1410.1c-31.44-7.95-75.95-15.53-113.64-8.18C2434.37,1313,2401.58,1216.45,2321.18,1147.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1882.2,1111.83c44.23,33.75,70.38,112,92.7,199.65-15,120.54-79.74,172.66-149.56,192.64a423.55,423.55,0,0,0-31.13-130C1883.42,1282,1882.2,1111.83,1882.2,1111.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1794.21,1374.11a423.55,423.55,0,0,1,31.13,130c-186.27,72.28-235.55-67.89-235.55-67.89l34.42-6.07C1702,1438.35,1756.26,1413.29,1794.21,1374.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1967.61,865.34l44.75,164.52a32,32,0,0,0,42.81,21.3c19.19-7.67,43.54-18.14,64.5-29.46a43.14,43.14,0,0,0,15.22-62l-93-138.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1504.41,1326.14l1146.81,417.39a87.81,87.81,0,0,1,49.9,118.87l-3.48,7.65a81.63,81.63,0,0,1-108.57,40.29L1475.53,1395.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 977.29,
    cy: 1075.07,
    rx: 566.12,
    ry: 555.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M347.35,1075.06c0,341.64,282,618.58,629.94,618.58s629.94-276.94,629.94-618.58-282-618.57-629.94-618.57S347.35,733.44,347.35,1075.06Zm92.54,0c0-291.44,240.6-527.71,537.4-527.71s537.4,236.27,537.4,527.71-240.6,527.71-537.4,527.71S439.89,1366.51,439.89,1075.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1559.34,1152.32c-.21,0-.41,0-.62,0a4.85,4.85,0,0,1-4.2-5.43c1.84-14.43,3.14-29.12,3.85-43.65a4.78,4.78,0,0,1,5.09-4.61,4.85,4.85,0,0,1,4.61,5.08c-.73,14.79-2,29.73-3.92,44.4A4.85,4.85,0,0,1,1559.34,1152.32Zm-4.33-173a4.87,4.87,0,0,1-4.78-4,560,560,0,0,0-33.43-114.43v0c-89.41-216.89-301.18-357-539.51-357-111.15,0-219.19,30.88-312.45,89.28a4.85,4.85,0,0,1-5.15-8.23c94.8-59.37,204.63-90.76,317.6-90.76,120.12,0,235.75,35.16,334.4,101.68,96.35,65,170.37,155.34,214.07,261.34v0a570.09,570.09,0,0,1,34,116.44,4.85,4.85,0,0,1-3.92,5.63A4.24,4.24,0,0,1,1555,979.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1869.69,740.34c-.4,2.83,37.33,187.75,37.33,187.75l105.13-23.79-9.72-180.58S1876.52,693,1869.69,740.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1978.78,764l12.57,94.66a13.3,13.3,0,0,1,0,3.62c-1.06,7.42-6.58,32.68-32.08,25.46-23.14-6.56-44.35-12.19-59-7.71a13.32,13.32,0,0,0-9.17,15.42c3.44,16.8,11.87,54.51,24.2,86.16a13.29,13.29,0,0,0,16.15,7.87c19.94-5.81,61.65-19.25,92.67-37.92a13.32,13.32,0,0,0,6.5-12c-1-23.9-3.8-96.54-1.45-116.9,2.21-19.12,25.67-30.57,35.86-34.67a13.1,13.1,0,0,0,7.29-7.33c4.72-11.82,11.23-39.19-23.26-50.41a13.34,13.34,0,0,1-8.45-17.27c5.1-14.22,7.26-35.92-19.42-47.88-27.12-12.15-47.37,2.31-58.31,14.05a13.34,13.34,0,0,1-17,2c-3.13-2-7.15-2.62-12,.41a13.14,13.14,0,0,1-18.61-5.64c-6.49-13.33-19.73-27.61-46.28-23.06-47.11,8.07-52.44,60.27-40,90.86s63,18.94,88.38,3.52c19.29-11.72,44.31.57,55.2,7.13A13.22,13.22,0,0,1,1978.78,764Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2033.37,857.13s-19.36-54.24.53-67.52,49.37-6.38,42.88,32.9C2068.71,871.38,2033.37,857.13,2033.37,857.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M2443.36,1630.86,2335,1622,2288,1665.3s11.1,15.36,45.83,6.53,82.3-11,82.3-11,47.94,21.61,48.52-18.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1603.59,1461.88c-9.37,7.32-41.49-8-61.15-18.54a22.61,22.61,0,0,1-10.93-26.72c4.73-14.92,12.61-34.18,22.32-36.6C1570,1376,1642.23,1431.69,1603.59,1461.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2628.6,1894.92a4.85,4.85,0,0,1-1.59-9.44c32.1-11.1,48.9-29,50-53.24,1.06-24.58-14.5-47.43-38.72-56.88l-137.69-53.69a4.86,4.86,0,0,1,3.52-9.05l137.7,53.7c28.09,11,46.13,37.61,44.88,66.34-.85,19.67-11.34,46.39-56.48,62A4.61,4.61,0,0,1,2628.6,1894.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2459.89,1705.46a4.75,4.75,0,0,1-1.76-.34l-17.85-7a4.85,4.85,0,1,1,3.53-9l17.85,7a4.86,4.86,0,0,1-1.77,9.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 981.25,
    cy: 931.2,
    r: 529.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 976.93,
    cy: 936.44,
    r: 466.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 628.41,
    cy: 583.59,
    r: 21.87,
    transform: "translate(-13.48 1152.32) rotate(-84.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M647.76,574.27c.87,15.1,38.37,30.24,65.78,39.1l-1.14,12.45c-33.37-12.27-64.09-27.4-81-20.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 1077.91,
    cy: 722.03,
    r: 21.87,
    transform: "translate(-7.56 1432.64) rotate(-67.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1065,739.18c-7.69-13-48-9.3-76.38-4.62L983.91,723c35.28-4.39,69.51-5,81.39-18.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 601.55,
    cy: 864.82,
    r: 21.87,
    transform: "translate(-368.23 1276.3) rotate(-78.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M604.48,843.55c13.06,7.62,46.41-15.26,68.95-33.2l9.74,7.84c-28.67,21-58.26,38.25-61.9,56.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 832.9,
    cy: 750.78,
    r: 202.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 912.08,
    cy: 728.89,
    r: 21.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 799.33,
    cy: 755.33,
    r: 21.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 854.01,
    cy: 613.27,
    r: 21.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 707.14,
    cy: 662.22,
    r: 21.87,
    transform: "translate(-261.14 693.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 777.19,
    cy: 848.53,
    r: 21.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 928.75,
    cy: 848.53,
    r: 21.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 853.03,
    cy: 478.55,
    r: 21.87,
    transform: "translate(14.34 981.83) rotate(-60.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M868.53,493.41c-13.84,6.1-14.88,46.53-13.58,75.31L842.89,572c-.19-35.55,3.22-69.62-9.1-83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1035.19,596.56a21.88,21.88,0,1,0,30.93.51A21.87,21.87,0,0,0,1035.19,596.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1044.85,633c-12-9.19-47.94,9.37-72.53,24.38l-1.11-1.15a8.3,8.3,0,0,1,2-13.09c27.67-14.86,53.54-27.26,58.76-42.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 923.94,
    cy: 648.46,
    rx: 17.83,
    ry: 21.87,
    transform: "translate(-159.3 965.91) rotate(-51.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M923.2,667.09c-12.83-7.9-41.63,9.51-60.87,23.47l-1.24-1c-4.3-3.44-4.74-9.28-.87-11.72,22.07-13.91,43-25.58,44.54-39.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-65",
    cx: 1016.07,
    cy: 764.27,
    rx: 18.85,
    ry: 21.87,
    transform: "translate(-101.51 158.04) rotate(-8.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1004.21,777.21c-3.74-14.57-32.1-22.12-52.37-25.49l-.24-1.57c-.81-5.45,2.23-9.93,6.1-9,22,5.37,42.1,11.57,51,2.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 1064.2,
    cy: 859.15,
    r: 21.87,
    transform: "translate(-204.84 1369.25) rotate(-60.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1043.77,865.75c1.12-14.19-29.94-32.84-55.24-45.41a6.53,6.53,0,0,1-3.45-7.31l.79-3.43a2.91,2.91,0,0,1,4.22-1.9c30,16.23,57,33.89,74.07,29.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 867.74,
    cy: 855.99,
    rx: 18.93,
    ry: 17.66,
    transform: "translate(-342.11 707.78) rotate(-37.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M852.62,852c8.85-8.48,3.43-31.31-2.5-48.27-.64-1.82.37-4.23,2.44-5.82l2.41-1.86c1.32-1,3-.85,3.32.33,6.3,21,10.16,41.71,21.59,45.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 812.93,
    cy: 1018.48,
    r: 21.87,
    transform: "translate(-369.86 1565.46) rotate(-76.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M797.58,1003.47c12.88-5.53,15.08-40.67,14.53-68.71a8.2,8.2,0,0,1,6.14-8.11h0a4.56,4.56,0,0,1,5.72,4.47c-.49,33.33-3.19,64.36,8.3,77.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 964.92,
    cy: 526.81,
    r: 21.87,
    transform: "translate(122.54 1233.21) rotate(-68.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M973.86,546.34c-14.65.55-30,35.51-39.48,62.46a3.42,3.42,0,0,1-3.59,2.25h0a7.46,7.46,0,0,1-6.09-10.21c12-29.52,24.4-56,18.5-71.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-75",
    cx: 568.99,
    cy: 722.03,
    r: 21.87,
    transform: "translate(-318.35 962.23) rotate(-66.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M582,704.9c7.27,12.37,43.86,9.73,71.87,5.48a5.78,5.78,0,0,1,6.23,3.56h0a6,6,0,0,1-4.94,8.24c-32.39,3.56-62.53,5-73.55,17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M675.5,777.69c9.34-3.76,13.26-15.89,8.75-27.1s-15.73-17.25-25.08-13.49-13.26,15.88-8.75,27.09S666.16,781.44,675.5,777.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M677.45,741.41c6.94,12.5,38.13,12,61.88,9.5a5.67,5.67,0,0,1,5.54,3.83h0c1.49,3.7-.38,7.57-3.75,7.77-27.55,1.61-53.28,1.26-62,13.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-79",
    cx: 780.58,
    cy: 636.71,
    rx: 21.87,
    ry: 18.96,
    transform: "translate(-226.57 655.43) rotate(-40.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M797.21,639.25c-10,10.18-4.44,34,1.7,51.36.58,1.63-.46,4-2.5,5.75h0c-3,2.57-6.79,2.63-7.51.11-5.94-20.6-9.85-40.56-21.78-42.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 685.02,
    cy: 960.8,
    r: 21.87,
    transform: "translate(-94.41 74.87) rotate(-5.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M682.49,939.47c12.75,3.58,36.64-24.48,54-47a8.71,8.71,0,0,1,13.86.07h0a4,4,0,0,1-.1,5c-21.86,26.55-44.7,49.81-43.75,67.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 730.75,
    cy: 498.51,
    r: 21.87,
    transform: "matrix(1, -0.06, 0.06, 1, -29.75, 46.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M751.87,502.41c-8.21,12.7,13.13,47.05,30,70.39l-8.27,9.37c-19.69-29.6-35.56-59.94-53.23-64.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M948.66,967.88a21.87,21.87,0,1,0,.16,30.94A21.88,21.88,0,0,0,948.66,967.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M912.41,978.33c8.27-11.3-7.7-42.6-22.44-66.43a8.36,8.36,0,0,1,1.17-10.28h0a4.48,4.48,0,0,1,7.07.91c16.59,29,30.08,57.1,46.5,62.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 1083.52,
    cy: 902,
    r: 14.56,
    transform: "translate(-326.31 901.54) rotate(-39.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1096.4,895.79c.58,10.05,25.54,20.13,43.79,26l-.76,8.28c-22.21-8.16-42.66-18.23-53.9-13.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 1382.75,
    cy: 994.15,
    r: 14.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1374.14,1005.56c-5.12-8.67-31.93-6.18-50.85-3.07l-3.12-7.71c23.48-2.92,46.28-3.34,54.18-12.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 1065.64,
    cy: 1089.21,
    r: 14.56,
    transform: "translate(-455.84 1173.16) rotate(-48.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1067.59,1075c8.69,5.08,30.89-10.15,45.9-22.09l6.48,5.21c-19.08,14-38.78,25.46-41.21,37.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-93",
    cx: 1219.65,
    cy: 1013.29,
    r: 134.53,
    transform: "translate(-359.28 1159.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 1272.36,
    cy: 998.71,
    r: 14.56,
    transform: "translate(-195.42 319.05) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-95",
    cx: 1197.3,
    cy: 1016.32,
    r: 14.56,
    transform: "translate(-367.97 1144.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 1233.7,
    cy: 921.75,
    r: 14.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-97",
    cx: 1135.93,
    cy: 954.34,
    r: 14.56,
    transform: "translate(-342.11 1082.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 1182.56,
    cy: 1078.36,
    r: 14.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-99",
    cx: 1283.45,
    cy: 1078.36,
    r: 14.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-100",
    cx: 1233.04,
    cy: 832.07,
    r: 14.56,
    transform: "translate(-221.34 519.81) rotate(-21.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1243.37,842c-9.22,4.06-9.91,31-9,50.14l-8,2.19c-.13-23.67,2.14-46.35-6.06-55.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1354.31,910.63a14.56,14.56,0,1,0,20.59.33A14.56,14.56,0,0,0,1354.31,910.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1360.74,934.9c-8-6.12-31.91,6.24-48.29,16.23l-.73-.76a5.53,5.53,0,0,1,1.35-8.72c18.43-9.89,35.64-18.14,39.12-28.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1268.87,936.09c-4.09,5.13-2.31,13.35,4,18.36s14.7,4.94,18.79-.19,2.31-13.34-4-18.36S1273,931,1268.87,936.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1279.76,957.58c-8.54-5.26-27.71,6.33-40.52,15.62l-.83-.66c-2.86-2.29-3.15-6.18-.58-7.8,14.69-9.26,28.63-17,29.65-26.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 1341.58,
    cy: 1022.27,
    rx: 12.55,
    ry: 14.56,
    transform: "translate(-135.99 208.84) rotate(-8.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1333.69,1030.88c-2.5-9.69-21.38-14.72-34.87-17l-.16-1c-.54-3.63,1.49-6.61,4.06-6,14.68,3.57,28,7.69,34,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1376.91,1071.24a14.56,14.56,0,1,0,10.9,17.48A14.57,14.57,0,0,0,1376.91,1071.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1360,1089.83c.75-9.46-19.93-21.87-36.77-30.23a4.34,4.34,0,0,1-2.3-4.87l.53-2.28a1.94,1.94,0,0,1,2.81-1.27c20,10.81,38,22.56,49.3,19.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-110",
    cx: 1242.84,
    cy: 1083.33,
    rx: 12.6,
    ry: 11.76,
    transform: "translate(-402.88 984.02) rotate(-37.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1232.77,1080.7c5.9-5.65,2.29-20.85-1.66-32.14-.43-1.21.25-2.81,1.63-3.87l1.6-1.24c.88-.67,2-.57,2.21.22,4.19,13.95,6.76,27.77,14.37,30Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 1206.35,
    cy: 1191.5,
    r: 14.56,
    transform: "translate(-470.02 1445.91) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1196.13,1181.5c8.58-3.68,10-27.07,9.68-45.74a5.46,5.46,0,0,1,4.08-5.4h0a3,3,0,0,1,3.81,3c-.32,22.19-2.12,42.84,5.53,51.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 1307.53,
    cy: 864.2,
    r: 14.56,
    transform: "translate(-183.38 1347.57) rotate(-51.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1313.48,877.19c-9.75.37-20,23.64-26.28,41.58a2.26,2.26,0,0,1-2.39,1.5h0a5,5,0,0,1-4-6.79c8-19.65,16.24-37.28,12.31-47.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 1043.96,
    cy: 994.15,
    r: 14.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1052.59,982.75c4.84,8.23,29.2,6.47,47.84,3.65a3.85,3.85,0,0,1,4.15,2.36h0a4,4,0,0,1-3.28,5.49c-21.57,2.37-41.63,3.32-49,11.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-118",
    cx: 1109.43,
    cy: 1017.69,
    rx: 12.14,
    ry: 14.56,
    transform: "translate(-299.59 487.4) rotate(-21.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1116.17,1007.05c4.61,8.32,25.38,8,41.19,6.32a3.77,3.77,0,0,1,3.69,2.56h0c1,2.46-.26,5-2.5,5.17-18.34,1.07-35.47.84-41.26,8.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-120",
    cx: 1184.82,
    cy: 937.36,
    rx: 14.56,
    ry: 12.62,
    transform: "translate(-325.11 987.97) rotate(-40.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1195.89,939.05c-6.63,6.77-3,22.65,1.13,34.18.38,1.09-.31,2.68-1.67,3.83h0c-2,1.72-4.51,1.75-5,.08-3.95-13.72-6.55-27-14.49-28.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 1121.2,
    cy: 1153.1,
    r: 14.56,
    transform: "translate(-101.01 2198.53) rotate(-86.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1119.52,1138.9c8.49,2.38,24.39-16.3,35.94-31.28a5.79,5.79,0,0,1,9.22.05h0a2.67,2.67,0,0,1-.06,3.31c-14.55,17.68-29.76,33.15-29.13,44.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 1151.65,
    cy: 845.36,
    r: 14.56,
    transform: "translate(-270.66 979.34) rotate(-41.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1165.71,848c-5.47,8.45,8.74,31.32,20,46.86l-5.51,6.24c-13.11-19.71-23.67-39.9-35.43-42.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-126",
    cx: 1286.46,
    cy: 1168.16,
    r: 14.56,
    transform: "translate(-419.22 1500.15) rotate(-53.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1272.57,1164.77c5.51-7.53-5.12-28.36-14.93-44.23a5.56,5.56,0,0,1,.78-6.84h0a3,3,0,0,1,4.7.61c11,19.28,20,38,31,41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M784.47,1145.79a11.86,11.86,0,1,0-10.73-12.9A11.87,11.87,0,0,0,784.47,1145.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M796.05,1128.92c.47,8.19,20.8,16.4,35.67,21.2l-.62,6.75c-18.09-6.65-34.75-14.85-43.91-11.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 1029.29,
    cy: 1209.04,
    r: 11.86,
    transform: "translate(-9.33 8) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1022.28,1218.34c-4.17-7.06-26-5-41.42-2.5l-2.54-6.29c19.13-2.37,37.69-2.71,44.14-10.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 770.99,
    cy: 1286.47,
    r: 11.86,
    transform: "translate(-134.21 90.62) rotate(-6.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M772.58,1274.93c7.08,4.14,25.17-8.27,37.39-18l5.28,4.25c-15.55,11.4-31.59,20.74-33.57,30.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 896.44,
    cy: 1224.63,
    r: 109.58,
    transform: "translate(-603.38 992.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 939.37,
    cy: 1212.76,
    r: 11.86,
    transform: "translate(-582.41 1019.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 878.23,
    cy: 1227.1,
    r: 11.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 907.89,
    cy: 1150.07,
    r: 11.86,
    transform: "translate(-547.31 978.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 828.25,
    cy: 1176.61,
    r: 11.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-139",
    cx: 866.23,
    cy: 1277.63,
    r: 11.86,
    transform: "translate(-649.71 986.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 948.41,
    cy: 1277.63,
    r: 11.86,
    transform: "translate(-268.17 252.08) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 907.35,
    cy: 1077.02,
    r: 11.86,
    transform: "translate(-498.01 986.31) rotate(-46.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M915.76,1085.08c-7.5,3.3-8.07,25.23-7.36,40.83l-6.54,1.79c-.11-19.28,1.74-37.75-4.94-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1006.13,1141a11.86,11.86,0,1,0,16.77.27A11.86,11.86,0,0,0,1006.13,1141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1011.37,1160.78c-6.52-5-26,5.08-39.34,13.22l-.59-.62a4.5,4.5,0,0,1,1.1-7.1c15-8.06,29-14.78,31.86-23.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-145",
    cx: 945.8,
    cy: 1169.15,
    rx: 9.67,
    ry: 11.86,
    transform: "translate(-557.98 1178.79) rotate(-51.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M945.4,1179.25c-6.95-4.28-22.57,5.16-33,12.73l-.68-.54c-2.33-1.86-2.57-5-.47-6.35,12-7.55,23.32-13.88,24.15-21.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-147",
    cx: 995.76,
    cy: 1231.94,
    rx: 10.22,
    ry: 11.86,
    transform: "translate(-170.67 160.19) rotate(-8.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M989.33,1239c-2-7.9-17.41-12-28.4-13.82l-.13-.85c-.44-3,1.21-5.39,3.31-4.88,12,2.92,22.83,6.28,27.65,1.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 1021.86,
    cy: 1283.39,
    r: 11.86,
    transform: "translate(-19.98 16.16) rotate(-0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1010.78,1287c.61-7.69-16.23-17.8-29.95-24.62a3.53,3.53,0,0,1-1.88-4l.44-1.86a1.57,1.57,0,0,1,2.28-1c16.3,8.8,30.93,18.37,40.17,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M923.46,1275.41c-3.23-4.18-9.49-4.77-14-1.31s-5.51,9.66-2.28,13.85,9.48,4.78,14,1.31S926.69,1279.6,923.46,1275.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M907.13,1279.54c4.8-4.6,1.86-17-1.36-26.18a3,3,0,0,1,1.33-3.15l1.31-1c.71-.55,1.6-.46,1.8.18,3.41,11.36,5.5,22.62,11.7,24.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-153",
    cx: 885.61,
    cy: 1369.79,
    r: 11.86,
    transform: "translate(-611.09 2018.26) rotate(-80.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M877.28,1361.65c7-3,8.18-22.06,7.88-37.26a4.46,4.46,0,0,1,3.33-4.4h0a2.48,2.48,0,0,1,3.1,2.43c-.26,18.07-1.72,34.9,4.51,41.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 968.02,
    cy: 1103.19,
    r: 11.86,
    transform: "translate(-251.52 1919.77) rotate(-82.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M972.87,1113.78c-7.94.3-16.26,19.25-21.41,33.86a1.83,1.83,0,0,1-1.94,1.22h0a4,4,0,0,1-3.3-5.53c6.5-16,13.23-30.36,10-38.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M757.76,1220a11.86,11.86,0,1,0-15.43-6.58A11.85,11.85,0,0,0,757.76,1220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M760.37,1199.75c3.94,6.71,23.78,5.28,39,3a3.13,3.13,0,0,1,3.37,1.92h0a3.26,3.26,0,0,1-2.67,4.47c-17.57,1.93-33.91,2.71-39.89,9.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M811.09,1239.22c5.06-2,7.19-8.62,4.75-14.69s-8.54-9.36-13.6-7.32-7.19,8.62-4.75,14.69S806,1241.26,811.09,1239.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M812.15,1219.55c3.76,6.78,20.67,6.52,33.55,5.15a3.08,3.08,0,0,1,3,2.08h0c.8,2-.21,4.1-2,4.21-14.94.87-28.89.69-33.61,7.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-161",
    cx: 868.07,
    cy: 1162.78,
    rx: 11.86,
    ry: 10.28,
    transform: "translate(-545.87 836.63) rotate(-40.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M877.09,1164.16c-5.41,5.52-2.41,18.45.92,27.84.31.89-.25,2.18-1.36,3.12h0c-1.65,1.4-3.68,1.43-4.07.06-3.22-11.17-5.34-22-11.81-23.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-163",
    cx: 816.25,
    cy: 1338.51,
    r: 11.86,
    transform: "translate(-739.56 1531.71) rotate(-65.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M814.88,1327c6.91,1.94,19.87-13.28,29.27-25.48a4.73,4.73,0,0,1,7.52,0h0a2.18,2.18,0,0,1-.06,2.69c-11.85,14.4-24.23,27-23.72,36.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-165",
    cx: 841.05,
    cy: 1087.84,
    r: 11.86,
    transform: "matrix(1, -0.06, 0.06, 1, -66.4, 54.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M852.5,1090c-4.45,6.88,7.12,25.51,16.28,38.16l-4.48,5.08c-10.68-16-19.28-32.5-28.86-34.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-167",
    cx: 950.86,
    cy: 1350.78,
    r: 11.86,
    transform: "translate(-6.95 4.92) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M939.55,1348c4.48-6.13-4.17-23.1-12.17-36a4.52,4.52,0,0,1,.64-5.57h0a2.43,2.43,0,0,1,3.83.5c9,15.7,16.31,31,25.22,33.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthImg4);
export default __webpack_public_path__ + "static/media/health_img_4.53650a9f58e0213284e34f387c90d36f.svg";
export { ForwardRef as ReactComponent };